import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      opacity: ".1",
      d: "M27.11 0h20.303v14.594c0 5.877-.518 10.5-1.553 13.872-1.036 3.372-2.963 6.419-5.78 9.14-2.818 2.721-6.37 4.853-10.657 6.394l-3.974-8.453c4.046-1.349 6.948-3.227 8.706-5.636 1.758-2.408 2.661-5.611 2.71-9.609H27.11V0ZM1.663 0h20.302v14.594c0 5.877-.506 10.5-1.517 13.872-1.012 3.372-2.927 6.419-5.744 9.14-2.818 2.721-6.394 4.853-10.73 6.394L0 35.547c4.094-1.349 7.008-3.227 8.742-5.636 1.734-2.408 2.65-5.611 2.746-9.609H1.662V0Z",
      fill: "#17191c"
    }, null, -1)
  ])))
}
export default { render };